import React, { useState, useEffect, useCallback } from 'react';
import AnimationLink from '../../../components/animation_link';
import './Introduction.css';
import ElevatorAnimation from '../../../assets/video/ElevatorAnimation.webm';

const Introduction = () => {
  const [showVideo, setShowVideo] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowVideo(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  const handleClickOutside = useCallback((e) => {
    if (e.target.classList.contains('introduction-container')) {
      setShowVideo(false);
    }
  }, []);

  return (
    <div className="introduction-page-container" >
      <video autoPlay loop muted className="background-video">
        <source src={ElevatorAnimation} type="video/webm" />
        Your browser does not support the video tag.
      </video>
      <div className="content">
        <div className="introduction-container" onClick={handleClickOutside}>
          {showVideo && (
            <div className="video-modal">
              <button className="close-button" onClick={() => setShowVideo(false)}>×</button>
              <div className="video-container">
              <iframe width="560" height="315" src="https://www.youtube.com/embed/KsBgk6alRQU?si=S-61AwVs0021mRBt" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
              </div>
              <div className="steam-link-container">
                <AnimationLink
                  targetId={'socialActive_steam'}
                  to={'https://store.steampowered.com/app/2134370?utm_source=web'}
                  dataValue={'WISHLIST ON STEAM'}
                  faIcon={'fa-brands fa-steam'}
                  isExternal={true}
                  style={{ whiteSpace: 'nowrap' }}
                />
              </div>
            </div>
          )}
          {!showVideo && (
            <div className="wishlist-button-container">
              <AnimationLink
                targetId={'socialActive_steam'}
                to={'https://store.steampowered.com/app/2134370?utm_source=web'}
                dataValue={'WISHLIST ON STEAM'}
                faIcon={'fa-brands fa-steam'}
                isExternal={true}
                style={{ whiteSpace: 'nowrap' }}
              />
            </div>
          )}
        </div>
      </div> 
    </div>
  );
};

export default Introduction;